
// TODO: Make these selectors
import {createSelector} from 'reselect';
import {NAMESPACE} from './constants';

export const deliverySelector = createSelector(
  (state) => state[NAMESPACE],
  (delivery) => delivery
);

export const deliveryIsComplete = (delivery = {}) => {
  if (!delivery.fulfillmentMethod) {
    return false;
  }

  if (delivery.deliverNow) {
    return true;
  }

  return !!delivery.inhandDate;
};
